import { render, staticRenderFns } from "./VerifyForgottenPassword.vue?vue&type=template&id=6af1635d"
import script from "./VerifyForgottenPassword.vue?vue&type=script&lang=js"
export * from "./VerifyForgottenPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports